import Axios from 'axios';
import { API, CONFIG } from '../utils/constant';

// Form Submission
function submitForm() {
    const contactForm = document.querySelector('#contact-form')
    if (contactForm == null || undefined) return

    const region = document.getElementById('form-project-region')
    const regionCheckbox = region.querySelectorAll('input[type="checkbox"]')
    let project
    let salutation
    let firstname
    let lastname
    let email
    let phone
    let source
    let remark
    let pdpa
    let regionCheckboxArr = []
    let isValid = false
    
    contactForm.addEventListener('submit', function(event){
        checkvalidation()
        event.preventDefault()

        if (isValid) {
            regionCheckbox.forEach( el => {
                const isChecked = el.checked
                if (isChecked) {
                    regionCheckboxArr.push(el.value)
                }
            })
            const regionValue = regionCheckboxArr.join(',')

            const payload = {
                full_name: `${salutation} ${firstname} ${lastname}`,
                email: email,
                phone_number: phone,
                bu_name: "EcoWorld Singapore",
                source: "Corporate Website",
                remarks_1: `Project Region: ${regionValue} \n Project: ${project}`,
                remarks_2: `Prospect Source: ${source} \n Message: ${remark}`
            }

            Axios.post(
                API,
                payload,
                CONFIG
            ).then( res => {
                console.log(res.data);
                console.log(new Date().toLocaleTimeString());
                alert('Thank you for your registration. Our sales consultants will be in touch with you.')
            }).catch( err => {
                console.log(err);
                if (err.response) {
                    console.log(err.response);
                }
            })
        }
    })
    
    function checkvalidation(){
        project = document.getElementById('form-project-name').value
        salutation = document.getElementById('form-salutation').value
        firstname = document.getElementById('form-first-name').value
        lastname = document.getElementById('form-last-name').value
        email = document.getElementById('form-email').value.toLowerCase()
        phone = document.getElementById('form-phone').value
        source = document.getElementById('form-source').value
        remark = document.getElementById('form-remark').value
        pdpa = document.getElementById('form-pdpa').checked
        let regionIsSelected = false
    
        regionCheckbox.forEach( el => {
            const isChecked = el.checked
            if (isChecked)
            regionIsSelected = true
        })
    
        if(!regionIsSelected){
            alert('Please select a project region.')
            isValid = false
        }
        else if(project == ""){
            alert('Please select a project.')
            isValid = false
        }
        else if(salutation == ""){
            alert('Please select your salutation.')
            isValid = false
        }
        else if (firstname == ""){
            alert('Please fill up your first name.')
            isValid = false
        }
        else if (lastname == ""){
            alert('Please fill up your last name.')
            isValid = false
        }
        else if (!validateEmail(email)){
            alert('Please fill up your email.')
            isValid = false
        }
        else if (phone == ""){
            alert('Please fill up your contact number.')
            isValid = false
        }
        else if (source == ""){
            alert('Please select an option on How do you hear about us?')
            isValid = false
        }
        else if (!pdpa){
            alert('Please read and agree the Terms & Conditions.')
            isValid = false
        } else {
            isValid = true
        }
    
        function validateEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }
}

export default submitForm;